import { defineMessages } from 'react-intl';

export const messages: {
	displayTextError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	displayTextLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	displayTextPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	displayTextLabel: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.display-text-label',
		defaultMessage: 'Display text',
		description:
			'Text shown as the field label above the display text input in the links menu item config panel, where the user enters the visible name for a menu item.',
	},
	displayTextPlaceholder: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder',
		defaultMessage: 'Item name',
		description: 'Placeholder text for the display text input',
	},
	displayTextError: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.display-text-error',
		defaultMessage: 'Please fill out this field.',
		description:
			'Validation error message shown below the display text input in the links menu item config panel when the user submits the form without entering a value.',
	},
});
